module.exports = __webpack_public_path__ + "img/cotoclub7.bcb099b7.png";